import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, useParams, useSearchParams } from 'react-router-dom';
import { AppState } from '../../../Store/rootReducer';
import { loadLibrary, setClient, setLocationId, setTargetAssignedToIdForNewApplications } from '../../../Store/Shared/actions';
import ApplicationFormPage from './ApplicationFormPage';
import CreditApplicationPage from './CreditApplicationPage';
import LoadingIndicator from '../../Shared/LoadingIndicator/LoadingIndicator';
import { useAppDispatch } from '../../../Store/useAppDispatch';

export interface ApplicationRouterProps {
  headerAndFooterHeight: number;
}

export default function ApplicationRouter(props: ApplicationRouterProps) {
  const params = useParams();
  const [searchParams] = useSearchParams();

  // Get useCuratedSite from query parameters
  const useCuratedSite = searchParams.get('useCuratedSite') === 'true';

  const embedCreditApplicationVersion = useSelector((state: AppState) => state.shared.embedCreditApplicationVersion);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const { clientId, amsCode, portalLinkId, salesPersonId } = params;
    if (clientId) {
      // if amsCode is present and not the customer portal link id, then load the library using the location id.
      amsCode && !portalLinkId
        ? dispatch(loadLibrary(clientId, amsCode))
        : dispatch(loadLibrary(clientId));

      dispatch(setClient(clientId));
    }
    if (amsCode && !portalLinkId) {
      dispatch(setLocationId(amsCode));
    }
    // Get the salesPersonId if it is present in the url parameters.
    if (salesPersonId) {
      dispatch(setTargetAssignedToIdForNewApplications(salesPersonId));
    }
    // TODO: Billy The portal link id can be used to find out the location id of the client and set it in the store.
    // We should implement this for all links. Store any information in the db and return it when the link is part of the url
    // during the validation process that pulls the associated application.
  }, [params]);

  if (!embedCreditApplicationVersion) {
    return <LoadingIndicator label={"Loading..."} />
  }

  if (embedCreditApplicationVersion === 1) {
    return <ApplicationFormPage headerAndFooterHeight={props.headerAndFooterHeight} useCuratedSite={useCuratedSite} />
  }
  return <CreditApplicationPage headerAndFooterHeight={props.headerAndFooterHeight} useCuratedSite={useCuratedSite} />
}